// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".show-on-map-popup[data-v-e88f0eda]  .modal{padding:40px!important;width:100%!important;min-height:600px!important}.show-on-map-popup[data-v-e88f0eda]  .modal .vue-map-container{position:absolute!important}.show-on-map-popup[data-v-e88f0eda]  .modal button.close{z-index:999!important}@media(max-width:960px){.show-on-map-popup[data-v-e88f0eda]  .modal .close{top:10px!important;right:10px!important}}", ""]);
// Exports
module.exports = exports;
